module.exports = __webpack_public_path__ + "static/images/artwork_600.jpg!static";